import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "draggable-container" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = ["onDragstart", "onDrop"]
const _hoisted_5 = {
  class: "fs-4 p-2",
  style: {"cursor":"all-scroll"}
}
const _hoisted_6 = { class: "border-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "las la-braille me-3 fs-4" }, null, -1)
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = ["onDragstart", "onDrop"]
const _hoisted_10 = {
  class: "fs-4 p-2",
  style: {"cursor":"all-scroll"}
}
const _hoisted_11 = { class: "border-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "las la-braille me-3 fs-4" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onDragstart", "onDrop"]
const _hoisted_15 = {
  class: "fs-4 p-2",
  style: {"cursor":"all-scroll"}
}
const _hoisted_16 = { class: "border-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "las la-braille me-3 fs-4" }, null, -1)
const _hoisted_18 = { class: "col-12 d-flex justify-content-end mt-5" }
const _hoisted_19 = ["data-kt-indicator"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Salvar Alterações ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Aguarde... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

import { updateOrder } from "@/services/CardapioService";
import { computed, reactive, ref, watch } from "vue";
import useAlert from "@/composables/Alert";
import useEmitter from "@/composables/Emmiter";

interface ItemSelect {
  name: string;
  codPackage: null | string | number;
  package: boolean;
  existChildren: boolean;
  icon: string;
  iconExpanded: string;
  level: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Order',
  props: {
    items: {},
    itemSelect: {}
  },
  setup(__props: any) {

const props = __props;

const { showTimeAlert } = useAlert();
const emitter = useEmitter();
const dateOrder = ref<string[] | []>([]);
const dateSelect = ref();
const codConcessionaria = ref(Number(localStorage.getItem("filtroConcessionaria")));
const loading = reactive({
  updateButton: false,
});
let draggedIndex = null;
const dragStart = (index) => {
  draggedIndex = index;
};
const firstHalf = computed(() =>
  dateOrder.value.slice(0, Math.ceil(dateOrder.value.length / 2))
);
const secondHalf = computed(() =>
  dateOrder.value.slice(Math.ceil(dateOrder.value.length / 2))
);

watch(
  () => props.itemSelect,
  (newValue) => {
    dateSelect.value = newValue;
    dateOrder.value = props.items;
    console.log("itemSelect", dateSelect.value);
    console.log("items", dateOrder.value);
  },
  { deep: true, immediate: true }
);

const saveOrdering = async () => {
  if (dateSelect) {
    const payload = {
      codConcessionaria: codConcessionaria.value,
      order: dateOrder.value,
      level: dateSelect.value?.level,
      car: dateSelect.value?.name ?? undefined,
      family: dateSelect.value?.family ?? undefined,
      codPacote: dateSelect.value?.codPackage ?? undefined,
    };

    loading.updateButton = true;
    await updateOrder(payload)
      .then(() => {
        showTimeAlert("Ordem Alterado com sucesso");
        emitter.emit("update-tree", {});
      })
      .catch(() => {
        showTimeAlert("Não foi possível completar a solicitação", "error");
      })
      .finally(() => (loading.updateButton = false));
  }
};

const drop = (index) => {
  if (draggedIndex !== null) {
    const temp = dateOrder.value[index];
    dateOrder.value[index] = dateOrder.value[draggedIndex];
    dateOrder.value[draggedIndex] = temp;
    draggedIndex = null;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.items.length > 20)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstHalf.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "draggable",
                  draggable: true,
                  onDragstart: ($event: any) => (dragStart(index)),
                  onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (drop(index))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(item), 1)
                    ])
                  ])
                ], 40, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondHalf.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "draggable",
                  draggable: true,
                  onDragstart: ($event: any) => (dragStart(index + firstHalf.value.length)),
                  onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (drop(index + firstHalf.value.length))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(item), 1)
                    ])
                  ])
                ], 40, _hoisted_9))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "draggable",
                draggable: true,
                onDragstart: ($event: any) => (dragStart(index)),
                onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                onDrop: ($event: any) => (drop(index))
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(item), 1)
                  ])
                ])
              ], 40, _hoisted_14))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-sm background_btn_1 text-white", { disabled: loading.updateButton || _ctx.items.length == 0 }]),
        "data-kt-indicator": loading.updateButton ? 'on' : 'off',
        id: "kt_button_1",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (saveOrdering()))
      }, _hoisted_22, 10, _hoisted_19)
    ])
  ]))
}
}

})